export default "__VITE_ASSET__B25JMk41__"